module.exports = __webpack_public_path__ + "img/team5.e7401127.png";